import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { IsAccountValidGuard } from './base/is-account-valid.guard';
import { LoadDomainGuard } from './base/load-domain.guard';
import { LoadServicesGuard } from './base/load-services.guard';

@Injectable({
  providedIn: 'root'
})
export class RedirectSsoGuard implements CanActivate {
  constructor(
    private loadDomainGuard: LoadDomainGuard,
    private loadServicesGuard: LoadServicesGuard,
    private isAccountValid: IsAccountValidGuard,
  ) { }

  canActivate(): Observable<boolean> {
    return this.loadDomainGuard.canActivate().pipe(mergeMap((domainLoaded: boolean) => {
      if (domainLoaded) {
        return this.loadServicesGuard.canActivate().pipe(mergeMap((servicesLoaded: boolean) => {
          if (servicesLoaded) {
            return this.isAccountValid.canActivate().pipe(mergeMap((valid: boolean) => {
              if (valid) {
                return of(true);
              }
            }));
          }
        }));
      }
    }));
  }
}
